import styled from 'styled-components';
interface IProps {
  hasDroplist?: boolean;
  isHighlight?: boolean;
  isTitleFullWidth?: boolean;
  hideBoxShadow?: boolean;
  showBorderBottom?: boolean;
}

export const CardStyled = styled.div<IProps>`
  width: 100%;
  border-bottom: ${(props) => (props.showBorderBottom ? '1px solid var(--p-color-border)' : '')};

  .disabled {
    opacity: 0.4;
  }

  .Polaris-ShadowBevel,
  > .Polaris-ShadowBevel > .Polaris-Box {
    height: 100%;
  }

  ${(props) =>
    props.hideBoxShadow
      ? `.Polaris-ShadowBevel {
      box-shadow: none !important;
      &::before {
        box-shadow: none !important;
      }
  }`
      : ''}
  ${(props) =>
    props.hasDroplist
      ? `> .Polaris-ShadowBevel , >.Polaris-ShadowBevel > .Polaris-Box {
    overflow: visible !important;
    border-radius: 12px;
  }`
      : ''}
  ${(props) =>
    props.isHighlight
      ? `> .Polaris-ShadowBevel , >.Polaris-ShadowBevel > .Polaris-Box {
    outline: 1px solid #0071bc;
  }`
      : ''}
  .custom-card-badge-top {
    background-color: #ffe600;
    width: fit-content;
    padding: 4px 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    outline: 2px solid #ffe600;
  }
  .yellow-border {
    > .Polaris-ShadowBevel,
    > .Polaris-ShadowBevel > .Polaris-Box {
      outline: 2px solid #ffe600;
      border-top-left-radius: 0;
    }

    > .Polaris-ShadowBevel:before {
      border-top-left-radius: 0;
      box-shadow: none;
    }
  }
  .custom-card-header {
    display: flex;
    justify-content: space-between;
    .custom-card-title {
      display: flex;
      align-items: center;
      > .Polaris-Text--root {
        font-size: calc(15 / 16 * 1rem);
      }
    }
    .custom-card-btn {
      display: flex;
      align-items: center;
    }
    .custom-secondary-btn {
      .Polaris-Button--iconOnly {
        height: 28px;
        margin-top: 8px;
      }
    }
    .Polaris-Text--root.Polaris-Text--headingMd {
      ${(props) => (props.isTitleFullWidth ? `width: 100%;` : '')}
    }
  }
`;
